import closeIcon from 'images/Icon_Cross_02.png';
import React from 'react';

type PopoutMenuHeaderProps = {
  title: string;
  handleClose: () => void;
};

export const PopoutMenuHeader: React.FC<PopoutMenuHeaderProps> = ({
  handleClose,
  title,
}) => {
  return (
    <div className="PopoutMenuTitleBar">
      <h1 className="PopoutMenuTitle">{title}</h1>
      <div className="CloseButton" onClick={handleClose}>
        <img src={closeIcon} className="CloseButtonImage" alt="Close" />
      </div>
    </div>
  );
};
